<template>
  <div>
    <v-btn class="mtfont" v-on:click="toggleDialog" text small>
      <span>REQUEST A PANTONE</span>
    </v-btn>
    <v-dialog v-model="prdialog" persistent max-width="600px">
      <v-card class="mtfont">
        <v-card-title>
          <span>NEW PANTONE REQUEST</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-card-subtitle>
                Hi! Thanks for your Pantone Request. Requests can take up to 72 hours. You will be notified by email
                when the request is completed.
              </v-card-subtitle>
              <v-card-text>
                We have a few Questions:
              </v-card-text>

              <v-card-text>
                1) Could you not find the formula?  Some colors need to be spelled out, like Cool Gray.
              </v-card-text>
              <v-card-text>
                2) Did you click the load formula button?
              </v-card-text>
              <v-card-text>
                3) After mixing: If color is inaccurate - How did you confirm the color was not correct?
              </v-card-text>
              <v-card-text>
                Note: Fluorescent and Metallic Pantones are not available for mixing at this time.  They require either
                a Fluorescent ink or a Metallic ink to match color. These are the Pantones in the 800 range.  We hope to
                have these inks available in the near future.  Thanks for your patience.
              </v-card-text>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field label="Name*" v-model="form.name" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Email*" v-model="form.email" required></v-text-field>
              </v-col>



              <v-col cols="12" sm="4">
                <v-text-field label="Pantone Code*" v-model="form.pantoneCode" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field label="Color Description*" v-model="form.colorDescription"></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-select :items="['URGENT', 'STANDARD', 'FEEDBACK',]" label="Status*" v-model="form.status"
                  required></v-select>
              </v-col>




              <v-col cols="12">
                <v-textarea label="Reason for Request*" v-model="form.comments" required minlength="8"></v-textarea>
              </v-col>

            </v-row>
          </v-container>
          <small>*indicates required field</small>
          <br>
          <small :style="'color:' + messageColor">{{ dialogMessage }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mtfont" color="black" text @click="prdialog = false">
            Close
          </v-btn>
          <v-btn class="mtfont" color="black" style="color: #fecb39;" type="submit" depressed @click="submitForm">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const graphify = obj => {
  const objKeys = Object.keys(obj);
  let graphString = objKeys.reduce((string, key) => {
    return (string + `${key}: "${obj[key]}",`);
  }, '{');
  return (graphString + '}');
};
export default {
  name: 'NewFormulaModal',

  data: () => ({
    prdialog: false,
    dialogMessage: '',
    form: {
      name: '',
      email: '',
      pantoneCode: '',
      colorDescription: '',
      status: '',
      comments: ''
    }
  }),
  computed: {
    messageColor: function () {
      return ~this.dialogMessage.indexOf('Error') ? 'red' : 'green'
    }
  },
  methods: {
    toggleDialog() {
      this.prdialog = true;
    },
    submitForm() {

      const runAlert = fieldName => {
        const alertMessage = `Please fill out ${fieldName} field to continue.`
        alert(alertMessage);
      }

      // Validate fields. For some reason the "required" property is not working.
      if (this.form.name === "") {
        runAlert("Name");
        return;
      } else if (this.form.pantoneCode === "") {
        runAlert("Pantone Code");
        return;
      } else if (this.form.email === "") {
        runAlert("Email");
        return;
      } else if (this.form.comments === "") {
        runAlert("Reason");
        return;
      } else if (this.form.colorDescription === "") {
        runAlert("Color Description");
        return;
      }

      const formObject = {
        name: this.form.name,
        code: this.form.pantoneCode,
        description: this.form.colorDescription,
        email: this.form.email,
        status: this.form.status,
        comments: this.form.comments
      };
      Object.keys(this.form).forEach(key => this.form[key] = '');
      this.$store
        .dispatch('submitPantoneRequest', formObject)
        .then(result => {
          console.log('Pantone request submitted:', result);

          this.dialogMessage =
            'Success! Your update request has been sent.';

          Object.keys(this.form).forEach(key => {
            this.form[key] = '';
          });

          this.prdialog = false;
        })
        .catch(error => {
          console.error('Pantone request failed:', error);

          this.dialogMessage =
            'Error! Something went wrong. For help, contact customer service.';
        });
    }
  }
}
</script>

<style scoped></style>